import { Box } from '@chakra-ui/react';
import React from 'react';

const LinkedInIcon = () => {
    return (
        <Box>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                class='lucide lucide-linkedin w-5 h-5 text-black-700'
                data-id='24'
            >
                <path d='M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z'></path>
                <rect width='4' height='12' x='2' y='9'></rect>
                <circle cx='4' cy='4' r='2'></circle>
            </svg>
        </Box>
    );
};

export default LinkedInIcon;
